<template>
  <div class="home">
    <navbar/> 
    <login/> 
  </div>
</template>

<script>

import login from '@/components/login.vue';
import navbar from '@/components/navbar.vue';
export default {
  name: 'HomeView',
  components: {
    login, 
    navbar
  }
}
</script>
